import { render, staticRenderFns } from "./OrdenCompraForm.vue?vue&type=template&id=6689b206&scoped=true&"
import script from "./OrdenCompraForm.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraForm.vue?vue&type=script&lang=js&"
import style0 from "./OrdenCompraForm.vue?vue&type=style&index=0&id=6689b206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6689b206",
  null
  
)

export default component.exports